<template>
  <div id="AmortizationTable">
    <div class="header">
      <div class="title">摊销表</div>
      <div class="baseInfo">
        <div class="unit">单位：</div>
        <div class="date">所属期间：{{accountInfoDataTime}}</div>
      </div>
    </div>
    <el-table
      :summary-method="getSummaries"
      :data="tableData"
      show-summary
      border
      style="width: 100%"
      :cell-style="{ borderColor: '#666666' }"
      :header-cell-style="{ borderColor: '#666666' }"
    >
      <el-table-column
        v-for="item in tableConfig"
        :key="item.prop"
        :label="item.label"
        :prop="item.prop"
        :width="item.width"
      >
        <template v-slot="scope" v-if="item.prop == 'index'">
          <span>{{ previousTotal + scope.$index + 1 }}</span>
        </template>
        <template v-slot="scope" v-else>
          <el-input
            size="mini"
            v-if="!showEdit"
            maxlength="15"
            v-model="scope.row[item.prop]"
          ></el-input>
          <span v-else>
            {{ scope.row[item.prop] }}
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import { uploadUrlTwo } from "@/assets/js/apiConfig.js";
import {AmortizationTableHeader} from "@/assets/js/printTemplate.js";
export default {
  props: {
    previousTotal: {
      type: Number,
      default: 0,
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    currentPage:{
      type:Number|String,
      default:1,
    },
  },
  data() {
    return {
      showEdit: false,
      tableConfig: AmortizationTableHeader,
    };
  },
  computed:{
    accountInfoDataTime() {
      return this.$util.formatDate.format(this.$store.state.accountInfo.accountInfoData.yearPeriodTimeStamp, "yyyy年MM月")
    },
  },
  mounted() {
    this.setColSpan();
  },
  methods: {
    setColSpan() {
      setTimeout(function () {
        if (document.querySelector("#AmortizationTable")) {
          var current = document
            .querySelector("#AmortizationTable")
            .querySelector(".el-table__footer-wrapper")
            .querySelector(".el-table__footer");
          var cell = current.rows[0].cells;

          cell[0].colSpan = "4";
          for (let i = 1; i < 4; i++) {
            cell[i].style.display = "none";
          }
        }
      }, 50);
    },
    // 自定义合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => {
          return Number(item[column.property]);
        });

        if (
          !values.every((value) => {
            isNaN(value);
          })
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              prev = Number(prev);
              if (prev + value) {
                return prev + value;
              } else {
                return prev + value ? prev + value : "";
              }
            } else {
              return prev ? prev : "";
            }
          }, 0);
        } else {
          sums[index] = "";
        }
      });
      if (sums) {
        return sums;
      } else {
        return "";
      }
    },
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(",");
      const bstr = atob(arr[1]);

      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: "image/png" });
    },
    changeEdit(key) {
      this.showEdit = key;
    },
    async generateImage(key) {
      await this.changeEdit(key);
      console.log(document.getElementById("AmortizationTable"))
      const element = document.getElementById("AmortizationTable");
      const canvas = await html2canvas(element, {
        useCORS: true, // 允许跨域图片
        logging: false, // 关闭警告
        width: 842,
        height: 562,
        // scale: 2,
        ignoreElements: (element) => false, // 强制渲染所有元素
      });
      console.log(canvas);
      const imgUrl = canvas.toDataURL("image/png");
      // 转 File 对象
      const file = this.dataURLtoFile(imgUrl, `摊销表_${this.currentPage}.png`);
      const formatDate = new FormData();
      formatDate.append("file", file);
      const { data } = await this.$http.post(uploadUrlTwo, formatDate, {
        upload: true,
      });
      return Promise.resolve(data.data[0]);
    },
  },
};
</script>

<style lang="less" scoped>
#AmortizationTable {
  padding: 2px;
}
/deep/ .el-table th.el-table__cell > .cell {
  display: flex;
  justify-content: center;
  align-items: center;
}
.header {
  height: 60px;
  border: 1px solid #666666;
  box-sizing: border-box;
  border-bottom: 0;
  display: flex;
  flex-direction: column;
  .title,
  .baseInfo {
    text-align: center;
    padding: 6px 0px;
    box-sizing: border-box;
    font-size: 12px;
    //   line-height: 30px;
    color: #333333;
  }
  .baseInfo {
    display: flex;
    padding: 0;
    .date {
      padding: 6px 0px;
      width: 130px;
      box-sizing: border-box;
    }
    .unit {
      flex: 1;
      box-sizing: border-box;
      padding: 6px 0px;
      border-right: 1px solid #666666;
    }
  }
  .title {
    border-bottom: 1px solid #666666;
  }
}
/deep/ .el-table__footer-wrapper td.el-table__cell {
  border-top: 1px solid #666666 !important;
  border-right: 1px solid #666666 !important;
}
/deep/ .el-table__cell {
  padding: 0 !important;
  .cell {
    text-align: center;
    padding: 2px !important;
    font-size: 12px !important;
    color: #333333 !important;
    line-height: 12px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 30px !important;
  }
}
/deep/ .el-table--border,
.el-table--group {
  border: 1px solid #666666 !important;
  // border-color: #666666!important;
}
</style>



// WEBPACK FOOTER //
// src/components/table/AmortizationTable.vue